import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useNavigation } from '@navigation';

import { RequestToCallSuccessProps } from './requestToCallInfoSuccess';

interface RequestToCallSuccessHelperResources {
	title: string;
	subTitle: string;
	buttonTitle: string;
}

interface RequestToCallSuccessHelperOutput {
	resources: RequestToCallSuccessHelperResources;
	back: () => void;
}

export const useRequestToCallSuccessHelper = ({
	nameToContact,
}: RequestToCallSuccessProps): RequestToCallSuccessHelperOutput => {
	const t = useTranslation();
	const { back } = useNavigation();

	const resources: RequestToCallSuccessHelperResources = {
		title: t('placeholders.requestToCallSuccess.title', { nameToContact }),
		subTitle: t('placeholders.requestToCallSuccess.subTitle'),
		buttonTitle: t('placeholders.requestToCallSuccess.button.title'),
	};

	return { resources, back };
};
